export const BLANK_CONVERTER = {
  encode: (v: any) => v,
  decode: (v: any) => v,
};
